import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const FooterWrapper = styled.footer`
    background: #007bff;
    color: white;
    text-align: center;
    padding: 20px 10px;
`;

export const Footer: React.FC = () => {
    const { t } = useTranslation();
    return (
        <FooterWrapper>
            <p>{t("footer.text")}</p>
        </FooterWrapper>
    );
};
